import type { CSSProperties, ReactElement } from "react";
import { Handle } from "@xyflow/react";
import type { MindmapNodeHandleModel } from "./mindmap-node-model";

const HANDLE_STYLE: CSSProperties = {
  width: 8,
  height: 8,
  backgroundColor: "transparent",
  backgroundImage: "none",
  border: "none",
  opacity: 0,
  pointerEvents: "none",
};

interface MindmapNodeHandlesProps {
  handles: MindmapNodeHandleModel[];
}

export function MindmapNodeHandles({
  handles,
}: MindmapNodeHandlesProps): ReactElement {
  return (
    <>
      {handles.map((handle) => (
        <Handle
          key={handle.type}
          type={handle.type}
          position={handle.position}
          style={HANDLE_STYLE}
        />
      ))}
    </>
  );
}
